import { useDispatch } from "react-redux";
import { fetchService } from "../services/fetchService"
import { createFailureAction } from "../state/reducer";
import { FetchError,FailureType } from "../typings";

const logPrefix = "[ADP Student App][FetchServiceHook]"
export function useFetchService() {
    const dispatch = useDispatch();
    const fetch = async (url:string, options:RequestInit = {} , 
        failureAction: FailureType = "NoServerConnectionDetected", codeToIgnore: number[] = [],returnResult=false,retries = 3): 
        Promise<Response | boolean | number | Blob | string> =>{
        
            try {
                const response =  await fetchService(url,options,retries);
                const contentLength = response.headers.get('content-length');
                if (contentLength && parseInt(contentLength, 10) === 0) {
                    return true;
                }
                const contentType = response.headers.get('content-type');
                if (contentType && contentType.includes('application/json')) {
                    // If the content is JSON, parse it
                    return  response.json();
                } else if (contentType && contentType.includes('text')) {
                    // If the content is text, parse it as text
                    return await response.text();
                } else {
                    // Handle other content types, e.g., blob, arrayBuffer, etc.
                    return await response.blob(); // or response.arrayBuffer(), etc.
                }
            }
            catch(e:any){
                console.error(logPrefix,e);
                const error = e?.cause as FetchError
                if(returnResult){
                    //do not emit error, let caller to decide
                    return false;
                }
                else if(error?.errorType === "API error"){
                    if(error?.response && codeToIgnore.includes(error?.response.status)){
                        return error.response; 
                    }
                    else if (error?.response && [400,500].includes(error?.response?.status)){
                        dispatch(createFailureAction("ApplicationError"));
                    }
                    else {
                        dispatch(createFailureAction("NoServerConnectionDetected")); 
                    }
                   
                }
                else if(error?.errorType === "Network error"){
                    dispatch(createFailureAction("NoInternetConnectionDetected"));  
                }
                else {
                   dispatch(createFailureAction(failureAction));   
                }
                return false;
            }  
        
        
       
    }
    return {fetch}
}